export default {
   errorMsg:{
      required:"此项是必填选项",
      minValue:"数字必须大于",
      maxValue:"数字必须小于 ",
      minLength:"填入字符长度需大于 ",
      maxLength:"填入字符长度需小于 ",
      numeric: "请填入正整数",
      decimal: "请填入有效数字",
      policy: "此项只能填写字母，数字以及 '-'",
      email: "请填入有效电子邮件",
      alphaNum: "此项只能填写字母及数字",
      between: "数字必须介于 ",
      between_and: " 至 ",
    },
    alertMsg:{
      error:"发现未填写或错误的必填选项，请检查红色项目并重新提交。",
      
    },

}


// WEBPACK FOOTER //
// ./src/Validation/langs/zh_cn/index.js